import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function FixAppointment(props){

  const {cons_id}=useParams();
  const [inputValue, setInputValue] = useState('');
  const [patients, setPatients] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
    const [djangoTime, setDjangoTime] = useState("");
  const [consData, setConsData] = useState([]);
  const [gender, setGender] = useState("male");
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
 const [selectedDate, setSelectedDate] = useState(new Date());


  const [registerFormData, setRegisterFormData] = useState({
    "pat_id":'',
    "my_title":'',
    "patient":'',
    "age":'',
    "mobile":'',
    "address1":'',
    "gender":'',
    "refered":'',
    "status":'',
    "addedby":'',
    "ip_add":'',
  });
  const [appointmentFormData, setAppointmentFormData] = useState({
    "pat":'',
    "cons":'',
    "appt_id":'',
    "type":'',
    "appt_date":'',
    "appt_time":'',
    "refered":'',
    "status":'',
    "addedby":'',
    "ip_add":'',
  });
  const [billFormData, setBillFormData] = useState({
    "pat":'',
    "cons":'',
    "appt_id":'',
    "fee":'',
    "status":'',
    "addedby":'',
    "ip_add":'',
  });
  const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }
  useEffect(() => {
    if (searchClicked) {
      fetchData();
    }
  }, [searchClicked]);

 const handleDateChange = (date) => {
  if (date) {
    setSelectedDate(date);
  }
};


 const handleTimeChange = (value) => {
    setSelectedTime(value);

    // value can be "07:30 PM" or "19:30" depending on TimePicker config
    if (!value) return;

    let hours = 0, minutes = 0;

    if (value.includes("AM") || value.includes("PM")) {
      // handle 12-hour format with AM/PM
      const [timePart, meridian] = value.split(" ");
      [hours, minutes] = timePart.split(":").map(Number);

      if (meridian.toUpperCase() === "PM" && hours !== 12) hours += 12;
      if (meridian.toUpperCase() === "AM" && hours === 12) hours = 0;
    } else {
      // handle 24-hour format from react-time-picker
      [hours, minutes] = value.split(":").map(Number);
    }

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const seconds = "00";
    const microseconds = "000000";

    const djangoFormatted = `${formattedHours}:${formattedMinutes}:${seconds}.${microseconds}`;
    setDjangoTime(djangoFormatted);
  };

  // set default current time
  useEffect(() => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const microseconds = "000000";

    const ampm = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12;
    const displayTime = `${String(displayHours).padStart(2, "0")}:${minutes} ${ampm}`;

    setSelectedTime(displayTime);
    const djangoFormat = `${String(hours).padStart(2, "0")}:${minutes}:${seconds}.${microseconds}`;
    setDjangoTime(djangoFormat);
  }, []);

  useEffect(() => {
    try {
      axios.get(baseUrl + "edit-consultant/" + cons_id).then(function (response) {
        setConsData(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, []);



    const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}pat-search/?search=${searchTerm}`);
      setPatients(response.data);
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
    setIsLoading(false);
  };

  function handleSearchButtonClick() {
    setSearchClicked(true);
  }

  function handleSearchInputChange(event) {
    setSearchTerm(event.target.value);
  }

   const columns = [
    {field:'id', headerName:'Id'},
    {field:'pat_id', headerName:'Patient ID',
      renderCell: (params) => (
          <Link to={`/emr-details/${params.value}`}>
            {params.value}
          </Link>
      )
      },
    {field:'patient', headerName:'Patient', width:200},
    {field:'gender', headerName:'Gender'},
    {field:'age', headerName:'Age'},
        {field:'address1', headerName:'Address'},
    {field:'mobile', headerName:'mobile'},
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: (params) => (
        <button type="button" className="btn btn-success" onClick={() => submitApptHandler(params.row)}>
          Revisit
        </button>
      )
    },
  ];
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
  };
  const submitApptHandler = (patient) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You are about to fix an appointment for this patient.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, fix it!',
      cancelButtonText: 'No, cancel!',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        axios.post(`${baseUrl}get_appt_id/`)
          .then(response1 => {
            const appt_id = response1.data.value;
            formData.append('appt_id', appt_id);
            formData.append('pat', patient.id);
            formData.append('cons', cons_id);
            formData.append('type', 'revisit');
            formData.append('appt_date', selectedDate.toISOString().slice(0,10));

            formData.append('appt_time', djangoTime);
            formData.append('refered', patient.refered);
            formData.append('status', '1');
            formData.append('addedby', userName);
            formData.append('ip_add', ipAddress);
            formData.append('location', userLocation);
            axios.post(baseUrl + 'add-appointment/', formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
              .then((response2) => {
                if (response2.status == 200 || response2.status == 201) {
                  const apptId = response2.data.id;
                  formData.append('appt_id', appt_id);
                  formData.append('pat', patient.id);
                  formData.append('cons', cons_id);
                  formData.append('fee', consData.fees);
                  formData.append('status', '1');
                  formData.append('addedby', userName);
                  formData.append('ip_add', ipAddress);
                  formData.append('location', userLocation);
                  axios.post(baseUrl + 'op-bill-create/', formData, {
                    headers: {
                      'content-type': 'multiple/form-data'
                    }
                  })
                    .then((response3) => {
                      Swal.fire({
                        title: 'Appointment Fixed Successfully',
                        icon: 'success',
                        timer: 5000,
                        showConfirmButton: false
                      })
                    })
                  setTimeout(() => {
                    window.location.href = '/op-dep/';
                  }, 3000);
                }
              })
              .catch(error => {
                console.log(error);
                Swal.fire(
                  'Error!',
                  'Failed to add Patient. Please try again later.',
                  'error'
                );
              });
          })
          .catch(error => {
            console.log(error);
            Swal.fire(
              'Error!',
              'Failed to generate unique value. Please try again later.',
              'error'
            );
          });
      }
    });
  };
  const submitHandler = (e) => {
     e.preventDefault();
        axios.post(`${baseUrl}get_pat_id/`)
          .then(response => {
        const pat_id = response.data.value;
        const formData = new FormData();
        const refered = document.getElementById("refered").value;
        const title = document.getElementById("title").value;
        formData.append('pat_id',pat_id);
        formData.append('my_title',title);
        formData.append('patient',registerFormData.patient);
        formData.append('age',registerFormData.age);
        formData.append('gender',gender);
        formData.append('mobile',registerFormData.mobile);
        formData.append('address1',registerFormData.address);
        formData.append('refered',refered);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);
           axios.post(baseUrl+'add-patient/', formData, {
                      headers : {
                        'content-type': 'multiple/form-data'
                    }
           })
          .then((response1) => {
              if(response1.status==200 || response1.status==201){
                axios.post(`${baseUrl}get_appt_id/`)
                .then(response2 => {
                const appt_id = response2.data.value;
                formData.append('appt_id',appt_id);
                formData.append('pat',response1.data.id);
                formData.append('cons',cons_id);
                formData.append('type','new');
                formData.append('appt_date',selectedDate.toISOString().slice(0,10));
                formData.append('appt_time',selectedTime);
                formData.append('refered',refered);
                formData.append('status', '1');
                formData.append('addedby', userName);
                formData.append('ip_add', ipAddress);
                formData.append('location', userLocation);
                axios.post(baseUrl+'add-appointment/', formData)
                .then((response3) => {
                if(response3.status==200 || response3.status==201){
                    formData.append('appt_id',appt_id);
                    formData.append('pat', response1.data.id);
                    formData.append('cons',cons_id);
                    formData.append('fee',consData.fees);
                    formData.append('status', '1');
                    formData.append('addedby', userName);
                    formData.append('ip_add', ipAddress);
                    formData.append('location', userLocation);

                  axios.post(baseUrl+'op-bill-create/', formData, {
                      headers : {
                        'content-type': 'multiple/form-data'
                    }
                  })
                    .then((response4) => {
                      Swal.fire({
                      title: 'Patient registration done and Appointment Fixed',
                      icon: 'success',
                      timer: 5000,
                      showConfirmButton: false
                    });
                    })
                    setTimeout(() => {
                      window.location.href = '/op-dep/';
                    }, 3000);
                }
                })
                })
              }
            })
            .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add Patient. Please try again later.',
                    'error'
                  );
              });
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to generate unique value. Please try again later.',
                'error'
            );
          });
  };
    const buttonEnable = (registerFormData.patient!='') && (registerFormData.age!='') && (registerFormData.mobile!='')
    const buttonAppEnable = (searchTerm)
    return (
    <section className="container mt-4">
    <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
        <button className="nav-link active border-primary " id="nav-revisit-patient-tab" data-bs-toggle="tab"
            data-bs-target="#nav-revisit-patient" type="button" role="tab" aria-controls="nav-revisit-patient"
            aria-selected="true">Revisit Patient</button>
        <button className="nav-link border-success" id="nav-new-patient-tab" data-bs-toggle="tab"
            data-bs-target="#nav-new-patient" type="button" role="tab" aria-controls="nav-new-patient"
            aria-selected="false">New Patient</button>
      </div>
    </nav>

<div className="tab-content" id="nav-tabContent">
  <div className="tab-pane fade show active" id="nav-revisit-patient" role="tabpanel" aria-labelledby="nav-revisit-patient-tab">
    <form>
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <label className="col-sm-3 col-lg-2 control-label mt-4 mb-3">Revisit Patient ID</label>
          <div className="col-sm-9 col-lg-10 controls mb-2">
            <input className="form-control" type="headerName" placeholder="pat id" style={{width: 300}}
                value={searchTerm} onChange={handleSearchInputChange} />

          </div>
        </div>
      </div>
    </div>
    </form>
  <button className="btn btn-primary" onClick={() => fetchData()}>Search</button>
    <div className="row">
      <div className="col-md-12 mt-4">
         {!isLoading && patients.length > 0 ? (
            <div style={{ height: "100%", width: '100%' }} className="mt-4">
                <DataGrid
                autoHeight
                sx={{
                border: 2,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
                '& .MuiDataGrid-footerContainer': {
                  display: 'none',
                },
                }}
                rows= {patients}
                columns= {columns}
                autoHeight
                />
            </div>
        ) : (
          <></>
        )}
      </div>
    </div>
    <button type="button" disabled={!buttonAppEnable} onClick={submitApptHandler}
            className="btn btn-success mb-2">Revisit</button>

   </div>
     <div className="tab-pane fade" id="nav-new-patient" role="tabpanel" aria-labelledby="nav-new-patient-tab">
        <form>
            <div className="row">
            <label htmlFor="Role" className="form-label">Patient Name</label>
            <div className="col-md-3 mb-3">
                  <select className="form-control" value={registerFormData.title} onChange={inputHandler}
                    name="title" id="title">
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Master">Master</option>
                    <option value="Dr">Dr</option>
                    <option value="Baby">Baby</option>
                    <option value="Ms">Ms</option>
                  </select>
            </div>
            <div className="col-md-9 mb-3">
                <input type="text" placeholder="Patient Name" className="form-control"
                   name="patient" value={registerFormData.patient} onChange={inputHandler} />
            </div>
            </div>
            <div className="row">
            <div className="col-md-3 mb-3">
                <label htmlFor="Age" className="form-label">Age</label>
                <input type="text" placeholder="Age" className="form-control"
                   name="age" value={registerFormData.age} onChange={inputHandler} />
            </div>
            <div className="col-md-3 mb-3">
                <label htmlFor="Mobile" className="form-label">Mobile</label>
                <input type="number" maxLength={10} placeholder="Mobile" className="form-control"
                    name="mobile" value={registerFormData.mobile} onChange={inputHandler} />
            </div>
            <div className="col-md-6 mb-3">
                <label htmlFor="Address" className="form-label">Address</label>
                <input type="text" placeholder="Address" className="form-control"
                   name="address" value={registerFormData.address} onChange={inputHandler} />
            </div>
            </div>
            <div className="row">

            <div className="col-md-6 mb-3">
            <label htmlFor="Gender" className="form-label">Gender</label>
                <label className="radio-inline">

                <input type="radio" name="gender" value="male" checked={gender === "male"}
                 onChange={handleGenderChange}/> Male
                </label>
                <label className="radio-inline">
                <input type="radio" name="gender" value="female" checked={gender === "female"}
                 onChange={handleGenderChange} /> Female
                </label>
                <label className="radio-inline">
                <input type="radio" name="gender" value="transgender" checked={gender === "transgender"}
                 onChange={handleGenderChange} /> Transgender
                </label>
            </div>
            <div className="col-md-3 mb-3">
            <label htmlFor="Refered" className="form-label-control">Referred By</label>
                <select className="form-control" value={registerFormData.refered} onChange={inputHandler}
                  name="refered" id="refered">
                <option value="walkin">Walk-in</option>
                <option value="medicalcamp">Medical Campaign</option>
                <option value="friends">Friends</option>
                <option value="doctor">Doctor</option>
                <option value="paperad">Paper Adv</option>
                <option value="others">Others</option>
                </select>
            </div>
            </div>
            <div className="row">
            <div className="col-md-12 text-center mb-5">
            <button type="button" disabled={!buttonEnable} onClick={submitHandler}
            className="btn btn-success">Register</button>
            </div>
            </div>
            </form>
        </div>
      </div>
       <div className="row" style={{ border: '2px solid #2194d9', padding: '20px', marginBottom: '20px', borderRadius: '5px' }}>
  <div className="col-md-6">
    <div className="form-group">
      <label>Appointment Date:</label>
      <div className="col-sm-6 col-lg-10 controls">
        <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd" />
      </div>
    </div>
  </div>
  <div className="col-md-6">
    <div className="form-group">
      <label>Appointment Time:</label>

      <div className="col-sm-6 col-lg-10 controls">
          <TimePicker
            onChange={handleTimeChange}
            value={selectedTime}
            disableClock
              format="hh:mm a"
            clearIcon={null}
          />
        </div>
    </div>
  </div>
</div>

    </section>
    )
}

export default FixAppointment;